module.exports = __webpack_public_path__ + "f8a5e89391fec19f96cb636e25eae601.pdf";